import React from "react";
import { Alert, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import MfaSetupForm from "./MfaSetupForm";
import ChangePasswordForm from "./ChangePasswordForm";
import TrustedDevicesPanel from "./TrustedDevicesPanel";
import DeleteAccountPanel from "./DeleteAccountPanel";

const SecurityTab = () => {
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const params = new URLSearchParams(location.search || "");
  const adminMfaRequired = params.get("adminMfaRequired") === "1";

  return (
    <Stack spacing={2}>
      {adminMfaRequired ? (
        <Alert severity="warning">
          Multi-factor authentication is required for admin and super admin
          accounts before they can access the admin console.
        </Alert>
      ) : null}
      <MfaSetupForm />
      <TrustedDevicesPanel trustedDeviceEligible={Boolean(user?.trustedDeviceEligible)} />
      <ChangePasswordForm />
      {/* Danger zone last: destructive actions belong below everything routine. */}
      <DeleteAccountPanel />
    </Stack>
  );
};

export default SecurityTab;
